import './Speeches.css';
import '../index.css'
import ImageCard from '../components/ImageCard';
import Spacer from '../components/Spacer.js'

function Speeches() {
    let speeches = (
        <div>
            <p className='card-text'>För dig som önskar bidra till kvällens program via traditionellt tal, en kort hälsning eller något annat påhitt så kan du kontakta våra toastmasters Johan Boo och Jakob Hernnäs. Det finns inga förväntningar på att stå i rampjuset, men vi välkomnar alla initiativ med öppna armar.</p>
            <p className='card-text'>Eftersom vi är många som samlas uppskattar vi om ni håller era bidrag relativt korta. Runt 5 minuter brukar vara lagom för att vi ska hinna med och njuta av alla.</p>
            <p className='card-text'>Har du frågor om tal och spex kan du skicka ett mail till våra toastmasters på följande mailadress:</p>
            <p className='card-text'><i>tal.idajakob2027@gmail.com</i></p>
        </div>
    )

    return (
        <div className='home-main'>
            <p className='home-main-text'>Tal</p>
            <Spacer />
            <div className='image-cards-container'>
                <ImageCard
                    title=""
                    text={speeches}
                    imagePath="/speechpicture.png"
                    imageAlt="speechpicture"
                />
            </div>
            <Spacer />
        </div >
    );
}

export default Speeches;
